export default __webpack_public_path__ + "static/Screenshot4-37e98f0dea06beb4972b1970206c753f.jpg";